import { Task } from "./Task";
import { z } from "zod";

// eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match
export const Tasks = z.object({
    tasks: Task.array(),
});

export type Tasks = z.infer<typeof Tasks>;
